module.exports = __webpack_public_path__ + "public/img/duty_1.cd6fdc55.png";